import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon }          from '@fortawesome/react-fontawesome'
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import { invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
import { XYPlot,
          Crosshair,
          DiscreteColorLegend,
          FlexibleWidthXYPlot,
          HorizontalGridLines,
          LineSeries,
          LineMarkSeries,
          VerticalGridLines,
          SearchableDiscreteColorLegend,
          XAxis,
          YAxis }        from 'react-vis';
//import { invokeGetClientAssessmentSpecificReport } from "../../utils/AwsInvoke";

const axisProps = {
    tickSizeInner: 0,
    style: {line: {stroke: '#939393', strokeWidth: '1px'}}
};

const height_color                      = "#c22a2a";
const weight_color                      = "#6621c4";
const lean_tissue_mass_percent_color    = "#2e78e7";
const lean_tissue_mass_weight_color     = "#56e7fc";
const adipose_tissue_mass_percent_color = "#fc9856";
const adipose_tissue_mass_weight_color  = "#fc56a0"
const bmi_color                         = "#3da211";

const BODYCOMP_LEGEND = [
    {title: 'All',  data: "all_data", color: "#000", strokeWidth: 14},
    {title: 'Height',  data: "height_data", color: height_color, strokeWidth: 14},
    {title: 'Weight', data: "weight_data", color: weight_color, strokeWidth: 14 },
    {title: 'Lean Tissue Mass Percent', data: "lean_tissue_mass_percent_data", color: lean_tissue_mass_percent_color, strokeWidth: 14 },

    {title: 'Lean Tissue Mass Weight', data: "lean_tissue_mass_weight_data", color: lean_tissue_mass_weight_color, strokeWidth: 14 },
    {title: 'Adipose Tissue Mass Percent', data: "adipose_tissue_mass_percent_data", color: adipose_tissue_mass_percent_color, strokeWidth: 14 },
    {title: 'Adipose Tissue Mass Weight', data: "adipose_tissue_mass_weight_data", color: adipose_tissue_mass_weight_color, strokeWidth: 14 },
    {title: 'BMI', data: "bmi_data", color: bmi_color, strokeWidth: 14 },
];

var height_data                       = [];
var weight_data                       = [];
var lean_tissue_mass_percent_data     = [];
var lean_tissue_mass_weight_data      = [];
var adipose_tissue_mass_percent_data  = [];
var adipose_tissue_mass_weight_data   = [];
var bmi_data                          = [];

var legend1_title = "Height";
var legend2_title = "Weight";
var legend3_title = "Lean Tissue Mass Percent";
var legend5_title = "Lean Tissue Mass Weight";
var legend6_title = "Adipose Tissue Mass Percent";
var legend7_title = "Adipose Tissue Mass Weight";
var legend8_title = "BMI";

export default class AssessBodyComp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            title:     "Body Comp Assessment",
            max_y_val: 0,
            min_y_val: 0,
            all_data: true,
            yAxisLabel: "",
            crosshairPreValues:      [],
        }
    }

    componentDidMount() {

        try {
            this.getClientData();
        } catch (e) {
            alert(e);
        }
    }

    resetDataVals () {
        height_data                      = [];
        weight_data                      = [];
        lean_tissue_mass_percent_data    = [];
        lean_tissue_mass_weight_data     = [];
        adipose_tissue_mass_percent_data = [];
        adipose_tissue_mass_weight_data  = [];
        bmi_data                         = [];
    }

    getClientData = async () => {
        this.setState({
            loadingData: "Loading member data ... "
        })

        const results  = this.props.resultsBodyComp;

        var asessInbodyChartData = [];
        var max_yaxis_val        = [];

        // Reset all vals in case someone clicks "All" multiple times; we don't want multiple duplicate vals
        this.resetDataVals();

        if(results) {
            var data            = results.data.bodycomp;
            var ctr = 0;
            var max_array = [];
            ////  BEGIN: BUILD OUT GRAPH DATA  ////
            for(var key in data) {
                var height                      = data[key].height;
                var weight                      = data[key].weight
                var lean_tissue_mass_percent    = data[key].lean_tissue_mass_percent;
                var lean_tissue_mass_weight     = data[key].lean_tissue_mass_weight
                var adipose_tissue_mass_percent = data[key].adipose_tissue_mass_percent
                var adipose_tissue_mass_weight  = data[key].adipose_tissue_mass_weight;
                var bmi                         = data[key].bmi;
                var date_created                = data[key].date_created;
                var date                        = (new Date(date_created)).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })

                height_data.push({"x": date, "y": height});
                weight_data.push({"x": date, "y": weight});
                lean_tissue_mass_percent_data.push({"x": date, "y": lean_tissue_mass_percent});
                lean_tissue_mass_weight_data.push({"x": date, "y": lean_tissue_mass_weight});
                adipose_tissue_mass_percent_data.push({"x": date, "y": adipose_tissue_mass_percent});
                adipose_tissue_mass_weight_data.push({"x": date, "y": adipose_tissue_mass_weight});
                bmi_data.push({"x": date, "y": bmi});

                // Get Max Value of All Data points and then filter out the highest value to use in the y-axis //
                max_array.push(height, weight, lean_tissue_mass_percent, lean_tissue_mass_weight, adipose_tissue_mass_percent, adipose_tissue_mass_weight, bmi)
            }

            var max_y_val = Math.max(...max_array) + 35;
            console.log("data: " + data.length);
            this.setState({
                report_data: data.length,
                all_data: true,
                height_data: height_data,
                weight_data: weight_data,
                lean_tissue_mass_percent_data: lean_tissue_mass_percent_data,
                lean_tissue_mass_weight_data: lean_tissue_mass_weight_data,
                adipose_tissue_mass_percent_data: adipose_tissue_mass_percent_data,
                adipose_tissue_mass_weight_data: adipose_tissue_mass_weight_data,
                bmi_data: bmi_data,
                max_y_val: max_y_val,
                min_y_val: 0 // reset min y val
            })
        } else {
            //this.msgDataLoaded();
        }
    }

    onMouseLeavePreWorkout = () =>{
        this.setState({crosshairPreValues: []});
    }

    ////   Tooltip Hover   ////
    onNearestXPreWorkout = (value, {index}) => {
        var x   = height_data[index].y;
        var x2  = height_data[index].x;
        var y1  = weight_data[index].y;
        var y2  = lean_tissue_mass_percent_data[index].y;
        var y4  = lean_tissue_mass_weight_data[index].y;
        var y5  = adipose_tissue_mass_percent_data[index].y;
        var y6  = adipose_tissue_mass_weight_data[index].y;
        var y7  = bmi_data[index].y;

        this.setState({
                        crosshairPreValues: [{x: x2, y: y1}],
                        crossHairX:  x,
                        crossHairY1: y1,
                        crossHairY2: y2,
                        crossHairY4: y4,
                        crossHairY5: y5,
                        crossHairY6: y6,
                        crossHairY7: y7
                      });
    };

    getMaxYAxisVals (data) {
        var arr = []
        var data2 = eval(data); // get actual vals of array

        for(var key in data2)
            arr.push(data2[key].y);

        var max_y_val = Math.max(...arr) + 15;
        var min_y_val = Math.min(...arr) - 15;

        // Don't let min_y_val go below 0
        if(min_y_val < 0) min_y_val = 0;

        //console.log("max_y_val: " + max_y_val);
        //console.log("min_y_val: " + min_y_val);
        var maxMinObj = {};
        maxMinObj.max_y_val = max_y_val;
        maxMinObj.min_y_val = min_y_val;

        return maxMinObj;
    }

    handleLegendClick = item => {
        var data = item.data;
        var dataset;

        if(data === "all_data")
            this.setState({
                all_data: false
            }, () => {
                this.getClientData();
            });
        else {
            if(data === "height_data")                          dataset = {"height_data":height_data, yAxisLabel: "inchaes"};
            else if(data === "weight_data")                     dataset = {"weight_data":weight_data, yAxisLabel: "pounds"};
            else if(data === "lean_tissue_mass_percent_data")   dataset = {"lean_tissue_mass_percent_data":lean_tissue_mass_percent_data, yAxisLabel: "percent"};
            else if(data === "lean_tissue_mass_weight_data")    dataset = {"lean_tissue_mass_weight_data": lean_tissue_mass_weight_data, yAxisLabel: "pounds"};
            else if(data === "adipose_tissue_mass_percent_data")dataset = {"adipose_tissue_mass_percent_data": adipose_tissue_mass_percent_data, yAxisLabel: "percent"};
            else if(data === "adipose_tissue_mass_weight_data") dataset = {"adipose_tissue_mass_weight_data": adipose_tissue_mass_weight_data, yAxisLabel: "pounds"};
            else if(data === "bmi_data")                        dataset = {"bmi_data": bmi_data, yAxisLabel: "body mass index"};

            var maxMinObj = this.getMaxYAxisVals(data);
            var max_y_val = maxMinObj.max_y_val;
            var min_y_val = maxMinObj.min_y_val;

            // Clear out all data since we're fiultering out datasets
            this.setState({
                all_data: false,
                current_dataset: data,
                height_data: [],
                weight_data: [],
                lean_tissue_mass_percent_data: [],
                lean_tissue_mass_weight_data: [],
                adipose_tissue_mass_percent_data: [],
                adipose_tissue_mass_weight_data: [],
                bmi_data: [],
                max_y_val: max_y_val,
                min_y_val: min_y_val
            }, function (){
                this.setState(dataset);
            })
        }

        //const {items} = this.state;
        //item.disabled = !item.disabled;
    };

    getAllTooltip () {
        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "50%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend1_title }: {this.state.crossHairX} inches</span>
                    <span style={{display: "block",fontSize:16}}>{ legend2_title }: {this.state.crossHairY1} lbs</span>
                        <span style={{display: "block",fontSize:16}}>{ legend3_title }: {this.state.crossHairY2} %</span>
                        <span style={{display: "block",fontSize:16}}>{ legend5_title }: {this.state.crossHairY4} lbs</span>
                    </span>
                    <span style={{display:"inline-block", width: "50%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend6_title }: {this.state.crossHairY5} %</span>
                        <span style={{display: "block",fontSize:16}}>{ legend7_title }: {this.state.crossHairY6} lbs</span>
                        <span style={{display: "block",fontSize:16}}>{ legend8_title }: {this.state.crossHairY7} body mass index</span>
                    </span>
                </span>
    }

    // Show only 1 value in the tooltip hover //
    getSingleTooltip () {
        var dataset = this.state.current_dataset;
        var legend;
        var value;
        if(dataset == "height_data") {
            legend    = legend1_title;
            value     = this.state.crossHairX  + " inches";
        } else if(dataset == "weight_data") {
            legend    = legend2_title;
            value     = this.state.crossHairY1  + " pounds";
        } else if(dataset == "lean_tissue_mass_percent_data") {
            legend    = legend3_title;
            value     = this.state.crossHairY2 + " %";
        } else if(dataset == "lean_tissue_mass_weight_data") {
            legend    = legend5_title;
            value     = this.state.crossHairY4 + " pounds";
        } else if(dataset == "adipose_tissue_mass_percent_data") {
            legend    = legend6_title;
            value     = this.state.crossHairY5 + " %";
        } else if(dataset == "adipose_tissue_mass_weight_data") {
            legend    = legend7_title;
            value     = this.state.crossHairY6 + " pounds";
        } else if(dataset == "bmi_data") {
            legend    = legend8_title;
            value     = this.state.crossHairY7 + " body mass index";
        }

        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "100%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend }: { value }</span>
                    </span>
                </span>
    }

    render() {
        var title     = this.state.title;
        var max_y_val = this.state.max_y_val;
        var min_y_val = this.state.min_y_val;
        var all_data  = this.state.all_data;
        var report_data  = this.state.report_data;
        var no_data_text;
        if(report_data === 0)  no_data_text  = <div style={{position:"relative", top: 75, padding: 15, fontSize:18}}>There is no assessment data.</div>


        var tooltip;
        var tooltip_width = 340;
        if(all_data) {
            tooltip_width = 550;
            tooltip       = this.getAllTooltip();
        } else {
            tooltip       = this.getSingleTooltip();
        }

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                <div className="iconAddExercise35pxVertSpacer"></div>
                <span style={{position:"relative", left:-10}}>
                        <div style={{fontSize:22, textAlign:"center"}}>
                            <FontAwesomeIcon icon="male" style={{fontSize: '2.1em', paddingRight: 8 }}/>
                            <span style={{position:"relative", top:-8}}>
                                { title }
                                { no_data_text }
                            </span>
                        </div>
                        <span style={{display:"inline-block",width:"100%", border:"0px solid #000"}}>

                                <FlexibleWidthXYPlot height       = {200}
                                                     xType        = "ordinal"
                                                     yDomain      = {[min_y_val, max_y_val]}
                                                     onMouseLeave = {this.onMouseLeavePreWorkout}
                                                     onMouseDown  = {() => {
                                                         //this.setState({showModalProgressDetail: true})
                                                        /*if (heldValue) {
                                                          this.setState({heldValue: false});
                                                          return;
                                                        }*/
                                                        //this.setState({heldValue: crosshairValues});
                                                      }}
                                                     >
                                  <VerticalGridLines />
                                  <HorizontalGridLines />

                                  <XAxis title="" {...axisProps}
                                         tickFormat={String}/>

                                     <YAxis title={this.state.yAxisLabel} {...axisProps}
                                         //tickValues={[0,10,20,30,40,50,260]}
                                         tickFormat={String} />

                                  <LineMarkSeries data={this.state.height_data}           size={2.5} color={height_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.weight_data}          size={2.5} color={weight_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.lean_tissue_mass_percent_data}        size={2.5} color={lean_tissue_mass_percent_color} onNearestX={this.onNearestXPreWorkout}/>

                                  <LineMarkSeries data={this.state.lean_tissue_mass_weight_data}        size={2.5} color={lean_tissue_mass_weight_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.adipose_tissue_mass_percent_data}      size={2.5} color={adipose_tissue_mass_percent_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.adipose_tissue_mass_weight_data}              size={2.5} color={adipose_tissue_mass_weight_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.bmi_data}     size={2.5} color={bmi_color} onNearestX={this.onNearestXPreWorkout}/>

                                  <Crosshair values={this.state.crosshairPreValues} >
                                      <div style={{float: "left", background: 'black', borderRadius: 5, width: tooltip_width, maxWidth: tooltip_width, borderRadius:5, padding: 10, zIndex: 1000}}>
                                          <span style={{display:"inline-block", width:"100%", fontSize:18, textAlign:"center"}}>{ title }</span>
                                             <br/>
                                             { tooltip }
                                      </div>
                                  </Crosshair>

                                </FlexibleWidthXYPlot>
                                { /**********  LEGEND  ***********/ }
                                <div style={{float: "left",  zIndex: 10}}>
                                    <DiscreteColorLegend items={BODYCOMP_LEGEND}
                                                         orientation='horizontal'
                                                         onItemClick={this.handleLegendClick}
                                                         style={{display: "inline-block", position:"relative", width:900, top:-7, left:35}}/>
                                </div>
                        </span>
                 </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/report/AssessBodyComp.js